import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getParentNumbers } from "../../slices/codeBookSlice";

export const useGetParentNumbers = () => {
  const parentNumbers = useSelector(
    (state: RootState) => state.codeBook.parentNumbers
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getParentNumbers());
  }, [dispatch]);

  return parentNumbers;
};
